import { useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { buildCapabilitiesObject } from './const';

export function useCapability(capabilities, noCapabilityCallback = null) {
  const { businessTokenData } = useSelector((state) => state.authenticationReducer);

  useEffect(() => {
    const handleNoCapabilities = () => {
      if (Object.values(capabilitiesResult).includes((val) => val === false)) {
        if (typeof noCapabilityCallback === 'function') noCapabilityCallback();
      }
    };

    handleNoCapabilities();
  }, [businessTokenData, capabilitiesResult, noCapabilityCallback]);

  const capabilitiesResult = useMemo(
    () => buildCapabilitiesObject(businessTokenData, capabilities),
    [businessTokenData, capabilities]
  );

  return capabilitiesResult;
}
